
define('tmpl!core/templates/webidl-contiguous/serializer.html', ['deps/handlebars'], function (hb) { return hb.compile('<span class=\'idlSerializer\' id="{{obj.idlId}}" data-idl data-title=\'serializer\'>{{extAttr obj indent\n}}{{idn indent}}{{#tryLink obj}}serializer{{/tryLink\n}}{{#if values}} = <span class=\'idlSerializerValues\'>{{values}}</span>{{/if}};</span>\n');});

